import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { v4 as uuidv4 } from 'uuid';
import { SlateEditable } from '../enums';
import { useSlate, useSlateComponent, useSlateKit } from '../hooks';
import { addToChildren, isAcceptsAfter, isAcceptsBefore } from '../utils';
import { SlateComponentRenderer } from './SlateComponentRenderer.component';
export const BlockContainer = ({ childId, componentAdder: ComponentAdder, }) => {
    var _a, _b;
    const { kit, updateActiveBlock } = useSlateKit();
    ComponentAdder = ComponentAdder || kit.loadComponentAdder();
    const { mode, editable, slate, updateSlate } = useSlate();
    const { componentId = '' } = useSlateComponent();
    const component = slate.components[componentId];
    const permitToAdd = [SlateEditable.ALL, SlateEditable.ADD_COMPONENT].includes(editable);
    if (!component)
        childId = 'all';
    const slateComponent = component;
    const componentChildren = slateComponent
        ? (slateComponent === null || slateComponent === void 0 ? void 0 : slateComponent.children) || []
        : slate.rootComponents;
    let childrenIds = childId === 'all' ? componentChildren : componentChildren[childId] || [];
    if (!Array.isArray(childrenIds))
        childrenIds = [childrenIds];
    const children = childrenIds.map(child => (_jsx(SlateComponentRenderer, { componentIds: child }, child.toString())));
    if (mode === 'live')
        return _jsx(_Fragment, { children: children }, void 0);
    if (mode === 'preview')
        return null;
    const onAdd = (afterId) => e => {
        const id = uuidv4();
        const changes = {
            addedComponents: [
                {
                    id,
                    name: 'BlockPreview',
                    props: {},
                    acceptsAfter: true,
                    acceptsBefore: true,
                    acceptsChildren: true,
                    removable: true,
                },
            ],
        };
        const newChildren = addToChildren({
            children: componentChildren,
            newId: id,
            afterId,
            childId: childId === 'all' ? undefined : childId,
        });
        if (slateComponent) {
            changes.updatedComponents = [
                Object.assign(Object.assign({}, slateComponent), { children: newChildren }),
            ];
        }
        else {
            changes.rootComponents = newChildren;
        }
        updateSlate(changes);
        updateActiveBlock({
            id,
            name: 'Block Preview',
            Settings: kit.loadSettings('BlockPreview'),
        });
        e.stopPropagation();
    };
    const insertComponentAdder = (afterId) => {
        const key = afterId ? `add-block-${afterId}` : 'add-block';
        return ComponentAdder ? (_jsx(ComponentAdder, { onAdd: onAdd(afterId) }, key)) : null;
    };
    const acceptsBefore = permitToAdd &&
        isAcceptsBefore(slate.components, ((_b = (_a = children[0]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.componentIds) || []);
    const content = acceptsBefore ? [insertComponentAdder()] : [];
    children.forEach(child => {
        content.push(child);
        if (permitToAdd &&
            isAcceptsAfter(slate.components, child.props.componentIds)) {
            content.push(insertComponentAdder(child.props.componentIds));
        }
    });
    return _jsx(_Fragment, { children: content.filter(c => c) }, void 0);
};
//# sourceMappingURL=BlockContainer.component.js.map